import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const UserItem = ({ user: { login, avatar_url, html_url } }) => {
  return (
    <div className='card text-center' style={DivStyle}>
      <img
        src={avatar_url}
        alt=''
        className='round-img'
        style={{ width: '60px' }}
      />
      <h3>{login}</h3>

      <div>
        <Link to={`/user/${login}`} className='btn btn-dark btn-sm my-1'>
          More
        </Link>
      </div>
    </div>
  );
};

const DivStyle = {
  borderStyle: 'solid',
  borderWidth: '2px',
  borderColor: '#404E4D',
  borderRadius: '20px',
  backgroundColor: '#eee'
};
UserItem.propTypes = {
  users: PropTypes.object.isRequired,
};

export default UserItem;
